
import React, { useState,useEffect } from "react";
import { useParams,useNavigate } from "react-router-dom";

import gradeentryapi from '../api/submittedGradeRouter';
import loginapi from '../api/login';

import { APISERVERURL } from '../APIServerURL';

import Batch from '../components/SubmittedGradeBatchCard';

function MarksEntryBatches({accessToken,setAccessToken,setRefreshFailed}) {
  const navigate = useNavigate();
  const { courseCode,session } = useParams();

  const [batches,setBatches]=useState([]);    
  const [isAppLoaded,setIsAppLoaded]=useState(false);
  

  useEffect(()=>{
    const fetchAT=async ()=>{
      try{       
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await gradeentryapi.post('/getAllBatchesOfACourse',{session:session,courseCode:courseCode},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
        //alert(JSON.stringify(response.data.batches));
        setBatches(response.data.batches); 
        //alert(response.data);
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="admin")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await gradeentryapi.post('/getAllBatchesOfACourse',{session:session,courseCode:courseCode},{headers:{'Authorization':`Bearer ${nat}`}});                       
                        //alert(JSON.stringify(response.data));
                        setBatches(response.data.batches); 
                        //alert(response.data);
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
    }
    fetchAT();
  },[]);
  
  const handleGoBack = () => {
    navigate(`/submittedgradecourses`); 
  };
  
    return (
      <main className="w-full">
        <div className="flex flex-col items-center w-full">

        <div className="w-full bg-red-100 relative py-1">
            {/* Absolute Positioned Button */}
            <button  onClick={handleGoBack}  className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300 text-xs">
              BACK
            </button>

            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center">SUBMITTED GRADE BATCHES</h1>
            <p className="w-full text-center text-xs">{courseCode},{session}</p>     
          </div>

          <div className="flex flex-wrap justify-center gap-4 mt-4">
          {isAppLoaded ? (
            batches.length > 0 ? (
              batches.map((batch) => (
                <Batch key={batch.batch} batch={batch} session={session} courseCode={courseCode} />
              ))
            ) : (
              <p>No Batches available.</p>
            )
          ) : (
            <p>Please wait...</p>
          )}
          </div>
        </div>

     
      </main>
    )
  }
  
  export default MarksEntryBatches